<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEmpty from '../../../../app/components/list/ListEmpty.vue'
  import RegistrationStatusLabel from './labels/StatusLabel'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import DataService from '../../../services/dataService'
  import helperMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'
  import {clone} from 'lodash'

  const defaultFilters = {event_id: '', dates: [], status_id: ''}

  export default {
    components: {ListHeader, ListEmpty, RegistrationStatusLabel},
    mixins: [helperMixin],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        filters: clone(defaultFilters),
        list: [],
        dependencies: {
          main_events: [],
          registration_status: []
        }
      }
    },
    computed: {
      emptyList: function () {
        return this.list.length === 0
      }
    },
    mounted () {
      this.getDependencies()
      this.getRegistrations()
    },
    methods: {
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([{domain: 'main_event'}, {domain: 'registration_status'}]).then((result) => {
            this.dependencies = result
            resolve()
          })
        })
      },
      getRegistrations () {
        bus.$emit('show-loader')
        let data = this.getSearchData()
        const modalitiesCanSubmitPapers = ['participante', 'profissional', 'proponente']
        restfulService.post('registration', 'my', null, data)
          .then((response) => {
            response.forEach((item) => {
              item.open_submission = item.modalities.some((eventModalityRegistration) => {
                return eventModalityRegistration.event_modality.event.paper_types_with_submissions_opened.length > 0 &&
                  modalitiesCanSubmitPapers.indexOf(eventModalityRegistration.event_modality.modality.key) !== -1
              })
            })
            this.list = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isLoadingData = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      getSearchData () {
        const searchData = {}
        if (this.filters.event_id) {
          searchData.event_id = this.filters.event_id
        }
        if (this.filters.status_id) {
          searchData.status_id = this.filters.status_id
        }
        if (this.filters.dates && this.filters.dates.length > 0) {
          let startDate = this.dateFormat(this.filters.dates[0], 'en')
          let endDate = this.dateFormat(this.filters.dates[1], 'en')
          if (startDate.length > 0 && endDate.length > 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          } else if (startDate.length > 0 && endDate.length === 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = startDate + ' 23:59:59'
          } else if (startDate.length === 0 && endDate.length > 0) {
            searchData.start_date = endDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          }
        }
        return searchData
      },
      onFilter () {
        this.getRegistrations()
      },
      onFilterClean () {
        this.filters = clone(defaultFilters)
        this.getRegistrations()
      },
      canCancelRegistration (registration) {
        return registration.status.key !== 'cancelado' && registration.modalities.every(item => item.invoices.every(obj => obj.status.key === 'em_aberto' || obj.status.key === 'sem_custo'))
      },
      cancelRegistration (registration) {
        this.isSubmitted = true
        this.$swal({
          title: 'Deseja realmente cancelar sua inscrição?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            restfulService.put('registration', 'cancel', registration.id)
              .then(response => {
                this.isSubmitted = false
                let registrationIndex = this.list.map(item => item.id).indexOf(registration.id)
                this.list.splice(registrationIndex, 1, (Object.assign({}, registration, {
                  status_id: response.status_id,
                  status: {
                    id: response.status.id,
                    key: response.status.key,
                    name: response.status.name
                  }
                })))
                notifyService.success({hideLoader: true, message: 'Sua inscrição foi cancelada com sucesso.'})
                bus.$emit('hide-loader')
              })
              .catch(e => {
                this.isSubmitted = false
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      }
    }
  }
</script>

<template>
    <div class="custom-list">

        <h2>Inscrições</h2>
        <h4 class="header-subtitle">Eventos que você está inscrito</h4>

        <el-card class="el-card__search_list box-card">
            <div slot="header">
                <span>Filtrar Inscrições</span>
                <div class="el-search-buttons">
                    <el-button type="primary" size="small" @click="onFilter">
                        <i class="fa fa-filter"></i>
                        <span>Aplicar Filtro</span>
                    </el-button>
                    <el-button type="default" size="small" @click="onFilterClean">Limpar</el-button>
                </div>
            </div>
            <el-form :inline="true" :model="filters" class="demo-form-inline">
                <div>
                    <el-form-item label="Evento Principal">
                        <el-select v-model="filters.event_id"
                                   filterable
                                   clearable
                                   placeholder="Filtrar Evento"
                                   empty-text="Nenhum registro encontrado">
                            <el-option v-for="item in dependencies.main_events"
                                       :key="item.id"
                                       :label="item.title"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Data da Inscrição">
                        <el-date-picker
                                v-model="filters.dates"
                                type="daterange"
                                format="dd/MM/yyyy"
                                placeholder="Filtrar por data">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Situação">
                        <el-select v-model="filters.status_id"
                                   filterable
                                   clearable
                                   placeholder="Filtrar Situação"
                                   empty-text="Nenhum registro encontrado">
                            <el-option v-for="item in dependencies.registration_status"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>

        <div class="responsive-table">
            <table class="custom-table-list" v-if="!emptyList">
                <thead>
                <tr>
                    <th>Cód. Inscrição</th>
                    <th>Evento</th>
                    <th>Data da Inscrição</th>
                    <th>Instituição</th>
                    <th>Situação da Inscrição</th>
                    <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in list">
                    <td>{{item.id}}</td>
                    <td>{{item.main_event.title}}</td>
                    <td>{{item.created_at | dateTimeEnToBr}}</td>
                    <td>{{item.institution.name}}</td>
                    <td>
                        <div>
                            <registration-status-label :status-id="item.status_id"
                                                       :status-name="item.status.name"/>
                        </div>
                        <div class="small">Última Atualização: {{item.status_updated_at | dateTimeEnToBr }}</div>
                    </td>
                    <td>
                        <div class="table-btn-actions btn-4">
                            <router-link :to="{ name: 'registration.show', params: { id: item.id } }"
                                         class="el-button el-button--info el-button--small"
                                         title="Visualizar">
                                <i class="fa fa-eye"></i>
                            </router-link>
                            <router-link :to="{ name: 'registration.show', params: { id: item.id, tab: 'payment' } }"
                                         v-if="item.status.key === 'em_aberto'"
                                         class="el-button el-button--success el-button--small"
                                         title="Pagamento">
                                <i class="fa fa-dollar"></i>
                            </router-link>
                            <router-link :to="{ name: 'submission.home', params: { registrationId: item.id } }"
                                         v-if="item.open_submission && item.status.key !== 'cancelado'"
                                         class="el-button el-button--success el-button--small"
                                         title="Nova Submissão">
                                <i class="fa fa-plus"></i>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       @click="cancelRegistration(item)"
                                       v-if="!item.papers.length && canCancelRegistration(item)"
                                       title="Cancelar Inscrição">
                                <i class="fa fa-times"></i>
                            </el-button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <list-empty v-if="emptyList"
                    description="Nenhuma inscrição encontrada, verifique os filtros e tente novamente"/>

    </div>

</template>
